export default __webpack_public_path__ + "static/media/Open pore Reduction kit 1.6f38bd43.jpg";